import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme'

interface IProps {
  className?: string;
  children?: React.ReactNode;
}

const IconBarBase = (props: IProps) => 
  <div className={props.className}>
    {props.children}
  </div>

const IconBar = styled(IconBarBase)`
  position: absolute;
  z-index: 2000;
  right: 30px;
  top: 20px;
  & > * {
    margin-left: 8px;
  }
`

export { IconBar }
